<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="请求ID/接口名/返回描述/链路ID/错误信息"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="请求ID">
          <el-input
            v-model="listQuery.request_id"
            placeholder="精确查询"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="接口名">
          <el-input
            v-model="listQuery.source_api"
            placeholder="精确查询"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="链路追踪ID">
          <el-input
            v-model="listQuery.trace_id"
            placeholder="精确查询"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="请求ID" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.request_id }}
        </template>
      </el-table-column>

      <el-table-column label="接口名" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.source_api }}
        </template>
      </el-table-column>

      <el-table-column label="返回码" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.retcode === 0" type="success" size="mini">正常</el-tag>
          <el-tag v-else-if="scope.row.retcode === -1" type="danger" size="mini">系统异常</el-tag>
          <el-tag v-else-if="scope.row.retcode > 0" type="warning" size="mini">业务异常</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="HTTP状态" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.http_status }}
        </template>
      </el-table-column>

      <el-table-column label="返回描述" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.retdesc }}
        </template>
      </el-table-column>

      <el-table-column label="错误信息" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.error_message }}
        </template>
      </el-table-column>

      <el-table-column label="链路追踪ID" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.trace_id }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="JSON" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="hasExtraData(scope.row)">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="API请求响应详情"
      :visible.sync="dialogDetailVisible"
      width="900px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="请求ID" :span="2">
            {{ currentRow.request_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="接口名" :span="2">
            {{ currentRow.source_api || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="返回码">
            <el-tag v-if="currentRow.retcode === 0" type="success" size="mini">正常</el-tag>
            <el-tag v-else-if="currentRow.retcode === -1" type="danger" size="mini">系统异常</el-tag>
            <el-tag v-else-if="currentRow.retcode > 0" type="warning" size="mini">业务异常</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="HTTP状态">
            {{ currentRow.http_status || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="返回描述" :span="2">
            {{ currentRow.retdesc || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="错误信息" :span="2">
            {{ currentRow.error_message || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="链路追踪ID" :span="2">
            {{ currentRow.trace_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="创建时间" :span="2">
            {{ currentRow.created_at || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="json-section">
          <div class="json-label">请求JSON：</div>
          <div v-if="currentRow.request_json" class="json-content">
            <pre>{{ formatJson(currentRow.request_json) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">响应JSON：</div>
          <div v-if="currentRow.response_json" class="json-content">
            <pre>{{ formatJson(currentRow.response_json) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">请求体JSON：</div>
          <div v-if="currentRow.body_json" class="json-content">
            <pre>{{ formatJson(currentRow.body_json) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        request_id: undefined,
        source_api: undefined,
        trace_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 判断是否有额外JSON数据
    hasExtraData(row) {
      return row.request_json || row.response_json || row.body_json
    },
    // 格式化JSON字符串
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        const parsed = JSON.parse(jsonStr)
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    // 获取列表数据
    getList() {
      this.listLoading = true
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/log/apiRawLogList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        request_id: undefined,
        source_api: undefined,
        trace_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 600px;
  overflow: auto;
}
.json-section {
  margin-top: 15px;
  .json-label {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .json-empty {
    text-align: center;
    padding: 15px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
